<template>
<div class="cancel-refund">

  <!-- HEADER -->
  <div class="cr-head cr-panel">
    <div class="cr-title">İptal / İade Formu</div>
    <div class="cr-sub">Fatura numarasına göre sorgula, satır seç, talep oluştur.</div>
  </div>

  <!-- SEARCH -->
  <div class="cr-panel">
    <div class="cr-row">
      <div class="cr-field">
        <label class="cr-label">Fatura No</label>
        <input
          class="cr-input"
          type="text"
          v-model="query.invoiceNo"
          placeholder="Örn: GIB2025-000123"
        />
      </div>

      <div class="cr-field cr-field--small">
        <label class="cr-label">Tarih (opsiyonel)</label>
        <input class="cr-input" type="date" v-model="query.date" />
      </div>

      <button class="cr-btn cr-btn--primary" type="button" @click="sorgulaFatura">
        Sorgula
      </button>
    </div>

    <div v-if="loading" class="cr-info">Sorgulanıyor…</div>
    <div v-if="error" class="cr-error">{{ error }}</div>
  </div>

  <!-- INVOICE RESULT -->
  <div v-if="invoice" class="cr-grid" style="margin-top:15px">
    <div class="cr-panel">
      <div class="cr-panelhead">
        <div class="cr-paneltitle">Fatura Satırları</div>
        <div class="cr-mini">
          Seçili: <b>{{ selectedCount }}</b> • Tutar: <b>{{ selectedTotal }} TL</b>
        </div>
      </div>

      <div class="cr-table">
        <div class="cr-thead">
          <div>Seç</div>
          <div>Ürün</div>
          <div class="r">Adet</div>
          <div class="r">Birim</div>
          <div class="r">Seçilen</div>
        </div>

        <div
          class="cr-tr"
          v-for="(it, idx) in invoice.items"
          :key="it.guid || idx"
        >
          <div>
            <input type="checkbox" v-model="it._selected" @change="onSelectRow(it)" />
          </div>

          <div class="cr-prod">
            <div class="cr-prodname">{{ it.name }}</div>
            <div class="cr-prodcode">{{ it.code }}</div>
          </div>

          <div class="r">{{ it.qty }}</div>
          <div class="r">{{ it.price }} TL</div>

          <div class="r">
            <input
              class="cr-qty"
              type="number"
              min="0"
              :max="it.qty"
              :disabled="!it._selected"
              v-model.number="it._returnQty"
            />
          </div>
        </div>
      </div>

      <div class="cr-hint">
        Not: İade için satır seçip “Seçilen” alanına iade edilecek adedi girin.
      </div>
    </div>
    <!-- LEFT: INVOICE SUMMARY -->
    <div class="cr-panel">
      <div class="cr-panelhead">
        <div class="cr-paneltitle">Fatura Bilgisi</div>
        <span class="cr-badge" :class="invoice.status === 'Kesildi' ? 'ok' : 'warn'">
          {{ invoice.status }}
        </span>
      </div>

      <div class="cr-kv">
        <div><span>Fatura No</span><b>{{ invoice.no }}</b></div>
        <div><span>Tarih</span><b>{{ invoice.date }}</b></div>
        <div><span>Cari</span><b>{{ invoice.cari }}</b></div>
        <div><span>Toplam</span><b>{{ invoice.total }} TL</b></div>
      </div>

      <div class="cr-divider"></div>

      <div class="cr-actions">
        <div class="cr-toggle">
          <button
            type="button"
            class="cr-pill"
            :class="form.type === 'iptal' ? 'active' : ''"
            @click="form.type = 'iptal'"
          >İptal</button>

          <button
            type="button"
            class="cr-pill"
            :class="form.type === 'iade' ? 'active' : ''"
            @click="form.type = 'iade'"
          >İade</button>
        </div>

        <div class="cr-note">
          <b>{{ form.type === 'iptal' ? 'İptal' : 'İade' }}</b> talebi oluşturulacak.
        </div>
      </div>

      <div class="cr-divider"></div>

      <div class="cr-form">
        <div class="cr-field">
          <label class="cr-label">Sebep</label>
          <select class="cr-input" v-model="form.reason">
            <option value="" disabled>Seçiniz</option>
            <option value="musteri_vazgecti">Müşteri vazgeçti</option>
            <option value="yanlis_fatura">Yanlış fatura / yanlış cari</option>
            <option value="urun_hasari">Ürün hasarı</option>
            <option value="teslimat_sorunu">Teslimat sorunu</option>
            <option value="fiyat_hatasi">Fiyat/iskonto hatası</option>
            <option value="diger">Diğer</option>
          </select>
        </div>

        <div class="cr-field">
          <label class="cr-label">Açıklama</label>
          <textarea class="cr-textarea" v-model="form.note" placeholder="Kısa açıklama..."></textarea>
        </div>

        <label class="cr-check">
          <input type="checkbox" v-model="form.confirm" />
          <span>Bilgilerin doğruluğunu onaylıyorum.</span>
        </label>

        <button
          class="cr-btn cr-btn--danger"
          type="button"
          :disabled="!canSubmit"
          @click="talepGonder"
        >
          Talep Gönder
        </button>
      </div>
    </div>

    <!-- RIGHT: ITEMS TABLE -->


  </div>
</div>

</template>

<script>
import db from '../../db.js';
import searchStore from '../../store/index.js';
import fiyatHelper from '../../services/fiyat/yapas.js'  // yeni dosya

export default {
data: function () {
  return {
    loading: false,
    error: '',
    query: { invoiceNo: '', date: '' },

    invoice: null, // { no, date, cari, total, status, items: [...] }

    form: {
      type: 'iptal', // iptal | iade
      reason: '',
      note: '',
      confirm: false
    }
  }
},
async created() {
  this.$store.setLoading([false,''])

},

computed: {
  selectedCount: function () {
    if (!this.invoice || !this.invoice.items) return 0
    var i, c = 0
    for (i = 0; i < this.invoice.items.length; i++) {
      if (this.invoice.items[i]._selected) c++
    }
    return c
  },
  selectedTotal: function () {
    if (!this.invoice || !this.invoice.items) return '0'
    var i, sum = 0, it, qty
    for (i = 0; i < this.invoice.items.length; i++) {
      it = this.invoice.items[i]
      if (it._selected) {
        qty = Number(it._returnQty || 0)
        sum += qty * Number(it.price || 0)
      }
    }
    return sum.toFixed(2)
  },
  seciliSatirVarMi: function () {
    return this.selectedCount > 0
  },
  canSubmit: function () {
    // İptal: satır seçmek zorunlu değilse istersen burada gevşetebilirsin.
    if (!this.invoice) return false
    if (!this.form.reason) return false
    if (!this.form.confirm) return false

    if (this.form.type === 'iade') {
      return this.seciliSatirVarMi
    }
    return true
  }
},
methods: {
  sorgulaFatura: async function () {
    // Backend bağlayacağın yer
    // this.loading = true; this.error = '';
    // const res = await this.$request.post('...', this.query)
    // this.invoice = normalize(res.data)

    // demo:
    this.error = ''
    this.loading = true
    var self = this
    setTimeout(function () {
      self.invoice = {
        no: self.query.invoiceNo || 'GIB2025-000123',
        date: '2025-12-23',
        cari: 'ABC LTD.',
        total: '12500.00',
        status: 'Kesildi',
        items: [
          { code:'PRD-001', name:'Ürün A', qty: 10, price: 1250, _selected:false, _returnQty:0 },
          { code:'PRD-002', name:'Ürün B', qty: 5, price: 980, _selected:false, _returnQty:0 }
        ]
      }
      self.loading = false
    }, 400)
  },
  onSelectRow: function (it) {
    if (it._selected) {
      if (!it._returnQty || it._returnQty === 0) it._returnQty = 1
    } else {
      it._returnQty = 0
    }
  },
  talepGonder: function () {
    // Backend’e gidecek payload
    // invoiceNo + type + reason + note + selected items (iade ise)
    var payload = {
      invoiceNo: this.invoice.no,
      type: this.form.type,
      reason: this.form.reason,
      note: this.form.note,
      items: []
    }

    if (this.form.type === 'iade') {
      var i, it
      for (i = 0; i < this.invoice.items.length; i++) {
        it = this.invoice.items[i]
        if (it._selected && Number(it._returnQty || 0) > 0) {
          payload.items.push({ code: it.code, qty: Number(it._returnQty || 0), price: it.price })
        }
      }
    }

    // this.$request.post('crm/iptal-iade/create', payload) ...
    console.log('payload', payload)
  }
}


};
</script>
<style scoped>

.cancel-refund{ background:#f7f7f7; padding:14px; }
.cr-head{ margin-bottom:12px; }
.cr-title{ font-size:18px; font-weight:900; color:#111827; }
.cr-sub{ font-size:12px; color:#6b7280; margin-top:4px; }

.cr-grid{
  display:grid;
  grid-template-columns: 1fr 420px;
  gap:12px;
}

.cr-panel{
  background:#fff;
  border:1px solid #e9ecf3;
  border-radius:16px;
  box-shadow: 0 12px 26px rgba(17,24,39,0.06);
  overflow:hidden;
  padding:14px;
}

.cr-row{ display:flex; gap:10px; align-items:flex-end; flex-wrap:wrap; }
.cr-field{ flex:1 1 240px; min-width:0; }
.cr-field--small{ flex:0 0 180px; }

.cr-label{ display:block; font-size:12px; color:#6b7280; font-weight:800; margin-bottom:6px; }
.cr-input{
  width:100%;
  height:44px;
  border-radius:12px;
  border:1px solid #e5e7eb;
  background:#f9fafb;
  padding:0 12px;
  font-size:14px;
  outline:none;
}
.cr-input:focus{ border-color:#2563eb; box-shadow:0 0 0 4px rgba(37,99,235,.12); background:#fff; }

.cr-textarea{
  width:100%;
  min-height:90px;
  border-radius:12px;
  border:1px solid #e5e7eb;
  background:#f9fafb;
  padding:10px 12px;
  font-size:14px;
  outline:none;
  resize:vertical;
}
.cr-textarea:focus{ border-color:#2563eb; box-shadow:0 0 0 4px rgba(37,99,235,.12); background:#fff; }

.cr-btn{
  height:44px;
  border-radius:12px;
  border:0;
  padding:0 14px;
  font-weight:900;
  cursor:pointer;
  white-space:nowrap;
}
.cr-btn--primary{ background:#2563eb; color:#fff; }
.cr-btn--danger{ background:#b91c1c; color:#fff; width:100%; margin-top:8px; }
.cr-btn:disabled{ opacity:.55; cursor:not-allowed; }

.cr-info{ margin-top:10px; font-size:13px; color:#111827; }
.cr-error{ margin-top:10px; font-size:13px; color:#b91c1c; font-weight:800; }

.cr-panelhead{ display:flex; align-items:center; justify-content:space-between; gap:10px; padding-bottom:10px; border-bottom:1px solid #eef1f6; }
.cr-paneltitle{ font-size:14px; font-weight:900; color:#111827; }
.cr-mini{ font-size:12px; color:#6b7280; }

.cr-badge{
  font-size:11px;
  font-weight:900;
  padding:6px 10px;
  border-radius:999px;
  border:1px solid transparent;
}
.cr-badge.ok{ background:rgba(22,163,74,.12); color:#15803d; border-color:rgba(22,163,74,.22); }
.cr-badge.warn{ background:rgba(245,158,11,.12); color:#b45309; border-color:rgba(245,158,11,.22); }

.cr-kv{ display:grid; gap:8px; margin-top:12px; }
.cr-kv > div{ display:flex; justify-content:space-between; gap:10px; font-size:13px; }
.cr-kv span{ color:#6b7280; }
.cr-kv b{ color:#111827; font-weight:900; }

.cr-divider{ height:1px; background:#eef1f6; margin:12px 0; }

.cr-toggle{ display:flex; gap:8px; }
.cr-pill{
  border:1px solid #e5e7eb;
  background:#fff;
  color:#111827;
  font-weight:900;
  border-radius:999px;
  padding:8px 12px;
  cursor:pointer;
}
.cr-pill.active{ background:#111827; color:#fff; border-color:#111827; }
.cr-note{ font-size:12px; color:#6b7280; margin-top:10px; }

.cr-check{ display:flex; gap:10px; align-items:flex-start; margin-top:10px; font-size:12px; color:#374151; }
.cr-check input{ margin-top:2px; }

.cr-table{ margin-top:12px; border:1px solid #eef1f6; border-radius:14px; overflow:hidden; }
.cr-thead, .cr-tr{
  display:grid;
  grid-template-columns: 48px 1fr 90px 110px 110px;
  align-items:center;
  gap:8px;
  padding:10px 12px;
}
.cr-thead{ background:#fafafa; font-size:12px; color:#6b7280; font-weight:900; }
.cr-tr{ border-top:1px solid #f1f5f9; font-size:13px; }
.cr-tr:hover{ background:#fbfbfd; }

.cr-prodname{ font-weight:900; color:#111827; }
.cr-prodcode{ font-size:12px; color:#6b7280; margin-top:2px; }
.r{ text-align:right; }

.cr-qty{
  width:100%;
  height:36px;
  border-radius:10px;
  border:1px solid #e5e7eb;
  background:#f9fafb;
  padding:0 10px;
  text-align:right;
  outline:none;
}
.cr-qty:focus{ border-color:#2563eb; box-shadow:0 0 0 4px rgba(37,99,235,.12); background:#fff; }
.cr-hint{ margin-top:10px; font-size:12px; color:#6b7280; }

@media(max-width:980px){
  .cr-grid{ grid-template-columns: 1fr; }
}



</style>



// WEBPACK FOOTER //
// src/views/stok/iade.vue